"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateUSATaxes = void 0;
var federalConfig_1 = require("./federalConfig");
var stateConfig_1 = require("./stateConfig");
var state_1 = require("./state");
var helpers_1 = require("../../helpers");
// function formatDeductionsForNetWorthCalculation(deductions: Deduction[]) {
//   const formattedDeductions: { annualValue: number; preTax: boolean }[] =
//     deductions.map((ded) => ({
//       annualValue: ded.monthly_contribution * 12,
//       preTax: ded.preTax,
//     }));
//   return formattedDeductions;
// }
function calculateUSATaxes(input) {
    var _a;
    var standardDeduction = federalConfig_1.filingDetail[input.user.filing_status].standardDeduction;
    var incomes = input.incomes ? input.incomes : input.user.incomes;
    var W2Incomes = incomes.filter(function (inc) { return inc.type === "W2"; }) || [];
    // TOTAL INCOME BALANCES FOR 1099 & W2
    var total1099TaxableIncome = 0;
    var totalW2GrossIncome = 0;
    // DEDUCTION BALANCES
    var preTaxAccountDeductions = 0;
    var postTaxAccountDeductions = 0;
    // TAX BALANCES
    var FICATaxesTotal = 0;
    var socialSecurityTotal = 0;
    var medicareTotal = 0;
    var federalTaxes = 0;
    var stateTaxes = 0;
    // CALCULATE TOTAL 1099 INCOME
    total1099TaxableIncome =
        (incomes === null || incomes === void 0 ? void 0 : incomes.filter(function (inc) { return inc.type === "1099"; }).reduce(function (prev, acc) { return prev + acc.value.presentValue; }, 0)) || 0;
    // CALCULATE TOTAL W2 INCOME AND DEDUCTIONS
    for (var i = 0; i < (W2Incomes === null || W2Incomes === void 0 ? void 0 : W2Incomes.length); i++) {
        var formattedIncomeDeductions = (0, helpers_1.formatDeductionsForTaxCalculation)(input.user, incomes);
        preTaxAccountDeductions += formattedIncomeDeductions
            .filter(function (ded) { return ded.preTax; })
            .reduce(function (prev, acc) {
            return prev + acc.annualValue;
        }, 0);
        postTaxAccountDeductions += formattedIncomeDeductions
            .filter(function (ded) { return !ded.preTax; })
            .reduce(function (prev, acc) {
            return prev + acc.annualValue;
        }, 0);
        totalW2GrossIncome += W2Incomes[i].value.presentValue;
    }
    // TOTAL COMBINED W2 AND 1099 INCOME
    var totalIncome = totalW2GrossIncome + total1099TaxableIncome;
    var adjustedGrossIncome = totalW2GrossIncome - preTaxAccountDeductions + total1099TaxableIncome;
    var taxableIncome = adjustedGrossIncome - standardDeduction;
    // CALCULATING FICA ON W2 SALARIES
    // If not married, then the additional medicare tax is at $200,000 threshold
    if (input.user.filing_status !== "MARRIED_JOINTLY" &&
        input.user.filing_status !== "MARRIED_SEPARATELY") {
        if (totalW2GrossIncome < 160200) {
            socialSecurityTotal = totalW2GrossIncome * federalConfig_1.SOCIAL_SECURITY_TAX;
            medicareTotal = totalW2GrossIncome * federalConfig_1.MEDICARE_TAX;
            FICATaxesTotal = socialSecurityTotal + medicareTotal;
        }
        else if (totalW2GrossIncome > 160200 && totalW2GrossIncome <= 200000) {
            medicareTotal = totalW2GrossIncome * federalConfig_1.MEDICARE_TAX;
            socialSecurityTotal = federalConfig_1.MAX_SOCIAL_SECURITY_PAID;
            FICATaxesTotal = medicareTotal + socialSecurityTotal;
        }
        else {
            var salaryToBeTaxedAdditionalMedicare = totalW2GrossIncome - 200000;
            socialSecurityTotal = federalConfig_1.MAX_SOCIAL_SECURITY_PAID;
            medicareTotal =
                totalW2GrossIncome * federalConfig_1.MEDICARE_TAX +
                    salaryToBeTaxedAdditionalMedicare * federalConfig_1.ADDTL_MEDICARE_TAX;
            FICATaxesTotal = socialSecurityTotal + medicareTotal;
        }
        // If married jointly the addtl medicare tax is at $250,000
    }
    else if (input.user.filing_status === "MARRIED_JOINTLY") {
        if (totalW2GrossIncome < 160200) {
            socialSecurityTotal = totalW2GrossIncome * federalConfig_1.SOCIAL_SECURITY_TAX;
            medicareTotal = totalW2GrossIncome * federalConfig_1.MEDICARE_TAX;
            FICATaxesTotal = socialSecurityTotal + medicareTotal;
        }
        else if (totalW2GrossIncome > 160200 && totalW2GrossIncome <= 250000) {
            socialSecurityTotal = federalConfig_1.MAX_SOCIAL_SECURITY_PAID;
            medicareTotal = totalW2GrossIncome * federalConfig_1.MEDICARE_TAX;
            FICATaxesTotal = socialSecurityTotal + medicareTotal;
        }
        else {
            var salaryToBeTaxedAdditionalMedicare = totalW2GrossIncome - 250000;
            socialSecurityTotal = federalConfig_1.MAX_SOCIAL_SECURITY_PAID;
            medicareTotal =
                totalW2GrossIncome * federalConfig_1.MEDICARE_TAX +
                    salaryToBeTaxedAdditionalMedicare * federalConfig_1.ADDTL_MEDICARE_TAX;
            FICATaxesTotal = socialSecurityTotal + medicareTotal;
        }
        // If married-separate the additional medicare tax threshold is $125,000
    }
    else {
        if (totalW2GrossIncome < 125000) {
            socialSecurityTotal = totalW2GrossIncome * federalConfig_1.SOCIAL_SECURITY_TAX;
            medicareTotal = totalW2GrossIncome * federalConfig_1.MEDICARE_TAX;
            FICATaxesTotal = socialSecurityTotal + medicareTotal;
        }
        else if (totalW2GrossIncome > 125000 && totalW2GrossIncome < 160200) {
            var salaryToBeTaxedAdditionalMedicare = totalW2GrossIncome - 125000;
            socialSecurityTotal = totalW2GrossIncome * federalConfig_1.SOCIAL_SECURITY_TAX;
            medicareTotal =
                totalW2GrossIncome * federalConfig_1.MEDICARE_TAX +
                    salaryToBeTaxedAdditionalMedicare * federalConfig_1.ADDTL_MEDICARE_TAX;
            FICATaxesTotal = socialSecurityTotal + medicareTotal;
        }
        else {
            var salaryToBeTaxedAdditionalMedicare = totalW2GrossIncome - 125000;
            socialSecurityTotal = federalConfig_1.MAX_SOCIAL_SECURITY_PAID;
            medicareTotal =
                totalW2GrossIncome * federalConfig_1.MEDICARE_TAX +
                    salaryToBeTaxedAdditionalMedicare * federalConfig_1.ADDTL_MEDICARE_TAX;
            FICATaxesTotal = socialSecurityTotal + medicareTotal;
        }
    }
    // ALL 1099 INCOME WILL PAY 2.9% on MEDICARE ALWAYS
    if (total1099TaxableIncome > 0) {
        medicareTotal += total1099TaxableIncome * federalConfig_1.MEDICARE_TAX_1099;
    }
    // CALCULATING WHETHER ADDITIONAL MEDICARE TAX NEEDS TO BE APPLIED ON 1099 INCOME
    // IF NOT MARRIED AND W2 IS OVER 200000 THEN ALL OF 1099 GETS TAXED ADDITIONAL MEDICARE
    if (input.user.filing_status !== "MARRIED_JOINTLY" &&
        input.user.filing_status !== "MARRIED_SEPARATELY" &&
        total1099TaxableIncome > 0) {
        if (totalW2GrossIncome > 200000) {
            medicareTotal += federalConfig_1.ADDTL_MEDICARE_TAX * total1099TaxableIncome;
        }
        else {
            if (totalIncome > 200000) {
                var additionalAmountToBeTaxed = totalIncome - 200000;
                medicareTotal += additionalAmountToBeTaxed * federalConfig_1.ADDTL_MEDICARE_TAX;
            }
        }
    }
    // IF MARRIED JOINTLY AND W2 OVER 250000 THEN ALL 1099 TAXED ADDITIONAL MEDICARE
    else if (input.user.filing_status === "MARRIED_JOINTLY" &&
        total1099TaxableIncome > 0) {
        if (totalW2GrossIncome > 250000) {
            medicareTotal += federalConfig_1.ADDTL_MEDICARE_TAX * total1099TaxableIncome;
        }
        else {
            if (totalIncome > 250000) {
                var additionalAmountToBeTaxed = totalIncome - 250000;
                medicareTotal += additionalAmountToBeTaxed * federalConfig_1.ADDTL_MEDICARE_TAX;
            }
        }
    }
    else if (total1099TaxableIncome > 0) {
        if (totalW2GrossIncome > 125000) {
            medicareTotal += federalConfig_1.ADDTL_MEDICARE_TAX * total1099TaxableIncome;
        }
        else {
            if (totalIncome > 125000) {
                var additionalAmountToBeTaxed = totalIncome - 125000;
                medicareTotal += additionalAmountToBeTaxed * federalConfig_1.ADDTL_MEDICARE_TAX;
            }
        }
    }
    // END OF ADDTL MEDICARE LOOKUP
    // IF SOCIAL SECURITY IS NOT MAXED OUT AND THERE IS 1099 INCOME, THEN ALL 1099 INCOME UP TO 160200 taxed
    if (socialSecurityTotal !== federalConfig_1.MAX_SOCIAL_SECURITY_PAID &&
        total1099TaxableIncome > 0) {
        // If total w2 and 1099 is greater than 160,200 tax only remaining balance up to 160,200
        if (totalIncome > 160200) {
            var additional1099SocialSecurityTax = (160200 - totalW2GrossIncome) * federalConfig_1.SOCIAL_SECURITY_1099;
            socialSecurityTotal += additional1099SocialSecurityTax;
        }
        if (totalIncome < 160200) {
            socialSecurityTotal += total1099TaxableIncome * federalConfig_1.SOCIAL_SECURITY_1099;
        }
    }
    // END OF 1099 SOCIAL SECURITY APPLICATION
    // CALCULATE FEDERAL TAXES WITH TOTAL TAXABLE INCOME (1099 & W2)
    for (var _i = 0, _b = federalConfig_1.filingDetail[input.user.filing_status].taxDetail; _i < _b.length; _i++) {
        var interval = _b[_i];
        if (taxableIncome < interval[1]) {
            federalTaxes += (taxableIncome - interval[0]) * interval[2];
            break;
        }
        else {
            federalTaxes += (interval[1] - interval[0]) * interval[2];
        }
    }
    // Calculate TOTAL STATE TAXES WITH Adjusted Gross Income (W2 & 1099)
    if (input.user.state && stateConfig_1.stateTaxDetail[input.user.state].type !== "none") {
        var stateTaxBrackets = (_a = stateConfig_1.stateTaxDetail[input.user.state][input.user.filing_status]) === null || _a === void 0 ? void 0 : _a.brackets;
        stateTaxes = (0, state_1.handleStateTaxCalculation)(stateTaxBrackets, stateConfig_1.stateTaxDetail[input.user.state], adjustedGrossIncome, input.user.filing_status, federalTaxes);
    }
    // IF TAXABLE INCOME IS LESS THAN 0, THEN NO TAXES ARE TO BE TAKEN
    if (taxableIncome <= 0) {
        federalTaxes = 0;
        stateTaxes = 0;
    }
    var netIncome = totalIncome -
        (federalTaxes +
            socialSecurityTotal +
            medicareTotal +
            stateTaxes +
            postTaxAccountDeductions +
            preTaxAccountDeductions);
    return {
        region: "US",
        federalTaxes: federalTaxes / 12,
        // FICA: FICATaxesTotal,
        socialSecurity: socialSecurityTotal / 12,
        medicare: medicareTotal / 12,
        // netIncome: netIncome / 12,
        stateTaxes: stateTaxes / 12,
    };
}
exports.calculateUSATaxes = calculateUSATaxes;
// function runTest() {
//   const container = [];
//   for (let i = 0; i < Object.keys(stateTaxDetail).length; i++) {
//     container.push(
//       calculateUSATaxes({
//         user.filing_status: "head-of-household",
//         grossSalary: 100000,
//         state: Object.keys(stateTaxDetail)[i],
//       })
//     );
//   }
//   // console.log(container);
// }
// runTest();
